<template>
    <modal
        :active="active"
        :dismissable="dismissable"
        title="Export Options"
        @dismiss="dismiss"
    >

        <modal-body>

            <form @submit.prevent="onExport">

                <control-group title="Export Type">
                    <select 
                        v-control 
                        v-model="exportType"
                        @change="onChange"
                    >
                        <option>Dashboard</option>
                        <option>Widgets</option>
                    </select>
                </control-group>

                <control-group title="File Type">
                    <select 
                        v-control 
                        v-model="fileType" 
                    >
                        <option 
                            v-for="item in fileTypes" 
                            :key="item.value" 
                            :value="item.value"
                        >
                            {{ item.text }}
                        </option>
                    </select>
                </control-group>

            </form>

        </modal-body>

        <modal-actions>
			<btn primary @click="onExport">Export</btn>
			<btn link @click="cancel">Cancel</btn>
		</modal-actions>
    </modal>
</template>


<script>
    import { ModalMixin } from "pdk/mixins";


    export default {
        name: "export-options-modal",
        mixins: [ModalMixin],
        props: {
            dismissable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                exportType: "",
                fileType: ""
            };
        },
        computed: {
            fileTypes() {
                if (this.exportType === "Dashboard")
                    return [
                        { value: "CSV", text: "CSV" },
                        { value: "XLSX", text: "Spreadsheet (XLSX)" },
                        { value: "PNG", text: "Image File (PNG)" },
                        { value: "PDF", text: "PDF" }
                    ];
                
                return [
                    { value: "CSV", text: "CSV" },
                    { value: "XLSX", text: "Spreadsheet (XLSX)" }
                ];
            }
        },
        methods: {
            onOpen(){
                this.exportType = "Dashboard";
                this.fileType = "CSV";
            },
            onExport(e) {
                const options = {
                    exportType: this.exportType,
                    fileType: this.fileType
                };

                this.$emit("onExport", options);
                this.close();
            },
            onChange(e) {
                if (e.target.value === "Widgets")
                    this.fileType = "CSV";
            }
        }
    };
</script>
